import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons

// core components
import Button from "components/CustomButtons/Button.js";

//import noticeModalStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import noticeModalStyle from "assets/jss/material-dashboard-react/views/pageStyle";
import { makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import details from "assets/constants/config/config";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const useStyles = makeStyles(noticeModalStyle)
const NoticeModal = (props)=>{
  const classes=useStyles();
  const navigate=useNavigate()
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const handleClose = async () =>{
    if(props.noticeModalErrMsg === "Session timeout. Please login again !"){
      dispatch({ type: "SIGNOUT" });
      sessionStorage.removeItem('session');
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.APP_URL,
        authToken: authToken,
      });
      console.log(result?.data?.main,"datadatadata")
      setCallInProgress(false);
        window.location.href = result?.data?.main
      props?.closeModal ();
    }
    else{
    props?.closeModal ();}
  }
  
      return (
          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={props?.noticeModal}
          //   TransitionComponent={Transition}
            keepMounted
            onClose={() => handleClose()}
            aria-labelledby="notice-modal-slide-title"
            aria-describedby="notice-modal-slide-description"
          >
            <DialogTitle
              id="notice-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
            >
              <h4 
              className={classes.modalTitle}
              >
                {props?.noticeModalHeader}
              </h4>
            </DialogTitle>
            <DialogContent
              id="notice-modal-slide-description"
              className={classes.modalBody}
            >
              {props?.textField ? 
              <CustomeTextField
              label={props?.label}
              id={props?.id}
              value={props?.value || ""}
              setState={props?.onChange}
              /> 
            :
              <p>{props?.noticeModalErrMsg}</p>
            }
            </DialogContent>
            <DialogActions
              className={classes.modalFooter + " " + classes.modalFooterCenter}
            >
              <Button onClick={() => handleClose()} color="info" round   
              className={classes.nextButton}
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>
  )
  
  }

NoticeModal.propTypes = {
  classes: PropTypes.object.isRequired,
  noticeModal: PropTypes.bool.isRequired,
  noticeModalHeader: PropTypes.string,
  noticeModalErrMsg: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default withStyles(noticeModalStyle)(NoticeModal);
